import React from 'react';

import { themeStyle } from '@repo/ui/theming';

import { HamburgerButtonWrapper, HamburgerButton } from './styles';

const Hamburger: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <HamburgerButtonWrapper>
      <HamburgerButton aria-label="Navigation" onClick={onClick}>
        <svg
          fill="none"
          height="12px"
          viewBox="0 0 14 12"
          width="14px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            d="M0.00292836 0.999791C0.00292836 0.447621 0.45055 0 1.00272 0H13.0002C13.5524 0 14 0.447621 14 0.999791C14 1.55196 13.5524 1.99958 13.0002 1.99958H1.00272C0.45055 1.99958 0.00292836 1.55196 0.00292836 0.999791ZM0 5.84253C0 5.29036 0.447622 4.84274 0.999791 4.84274H13.0002C13.5524 4.84274 14 5.29036 14 5.84253C14 6.3947 13.5524 6.84232 13.0002 6.84232H0.999791C0.447622 6.84232 0 6.3947 0 5.84253ZM0.099139 10.6853C0.099139 10.1331 0.546761 9.68547 1.09893 9.68547H13.0002C13.5524 9.68547 14 10.1331 14 10.6853C14 11.2374 13.5524 11.6851 13.0002 11.6851H1.09893C0.546761 11.6851 0.099139 11.2374 0.099139 10.6853Z"
            fill={themeStyle.varInkMain}
            fillRule="evenodd"
          />
        </svg>
      </HamburgerButton>
    </HamburgerButtonWrapper>
  );
};

export default Hamburger;
